import { render, staticRenderFns } from "./newDigitalFormsFields.vue?vue&type=template&id=037dd58a&scoped=true"
import script from "./newDigitalFormsFields.vue?vue&type=script&lang=js"
export * from "./newDigitalFormsFields.vue?vue&type=script&lang=js"
import style0 from "./newDigitalFormsFields.vue?vue&type=style&index=0&id=037dd58a&prod&lang=css"
import style1 from "./newDigitalFormsFields.vue?vue&type=style&index=1&id=037dd58a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "037dd58a",
  null
  
)

export default component.exports